import { Link } from "react-router-dom";
import AppStoreLinks from "./AppStoreLinks";

const Footer = () => {
  return (
    <footer className="border-t border-ink-700 bg-ink-950 mt-12">
      <div className="max-w-6xl mx-auto px-6 py-10 flex flex-col gap-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
          <div>
            <div className="flex items-center space-x-2">
              <span
                aria-hidden
                className="w-1.5 h-1.5 rounded-full bg-accent-500"
              />
              <span className="font-display text-lg text-white">
                A Dark Place
              </span>
            </div>
            <p className="text-sm text-ink-400 mt-2 max-w-xs">
              Stories from the corners of the internet.
            </p>
          </div>

          <div className="text-sm text-ink-400 space-y-2">
            <div className="text-xs uppercase tracking-[0.25em] text-ink-500">
              Site
            </div>
            <Link to="/" className="block hover:text-white">
              Stories
            </Link>
            <Link to="/submit" className="block hover:text-white">
              Submit a story
            </Link>
            <Link to="/login" className="block hover:text-white">
              Sign in
            </Link>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.25em] text-ink-500 mb-3">
              Get the app
            </div>
            <AppStoreLinks variant="compact" />
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-3 pt-6 border-t border-ink-700/60 text-xs text-ink-500">
          <span>© {new Date().getFullYear()} A Dark Place</span>
          <span>
            Tales gathered from the internet and submitted by readers.
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
